export const customer_module_names = {
  profile_module: 'Profile',
  dashboard_module: 'Dashboard',
  users_module: 'Users',
  subscription_module: 'Subscriptions',
  invoice_module: 'Invoices',
  payment_module: 'Payments',
  support_ticket_module: 'Support Ticket',
};
